<template>
    <div class="field" :class="{'is-error': isInvalid}">
        <label v-if="label" class="field-label">{{label}}</label>
        <div class="field-group">
            <div class="field-addon no-flex text-muted" v-if="leftLabel">{{leftLabel}}</div>
            <div class="field-control has-icon-right">
                <input
                    class="field-input"
                    :value="value"
                    @input="updateTyped"
                    @focus="openIfEmpty"
                    :placeholder="placeholder"/>
                <v-popper2
                    ref="menu"
                    position="bottomEnd"
                    class="position-absolute"
                    :offset="10"
                    style="right:6px;top:8px;width:auto;">
                    <template #trigger="{popper}">
                        <v-icon
                            @click="popper.toggle"
                            icon="caret-down"
                            class="cursor-pointer"/>
                    </template>
                    <template #content="{popper}">
                        <div class="popover">
                            <div class="popover-control">
                                <div class="popover-content popover-menu">
                                    <a
                                        v-for="(option, index) in baseOptions"
                                        :key="index"
                                        href="#"
                                        class="popover-menu-item"
                                        @click.prevent="selectBaseOption(option, popper)">{{option.label}}</a>
                                </div>
                                <div class="popover-content popover-content-secondary">
                                    <a href="https://help.rebilly.com/en/articles/3296639-relative-time-filters" target="_blank">Learn about relative time formats</a>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-popper2>
            </div>
        </div>
        <span class="field-caption" v-if="helpText">{{helpText}}</span>
    </div>
</template>

<script>
    import vIcon from './v-icon';
    import vPopper2 from '@/components/popper/v-popper2';
    import vIconButton from './v-icon-button';
    import isBlank from '@/common/helpers/is-blank';

    const defaultValues = {
        oneWeekAgo: '1 week ago',
        oneDayAgo: '1 day ago',
        oneYearAgo: '1 year ago',
        now: 'now',
    };

    export default {
        name: 'v-relative-date-input',
        components: {
            vIcon,
            vIconButton,
            vPopper2,
        },
        props: {
            label: String,
            leftLabel: String,
            placeholder: String,
            helpText: String,
            value: String,
        },
        computed: {
            isInvalid() {
                return false;
            },
        },
        data() {
            return {
                baseOptions: [
                    {
                        label: '1 day ago',
                        value: defaultValues.oneDayAgo,
                    },
                    {
                        label: '1 week ago',
                        value: defaultValues.oneWeekAgo,
                    },
                    {
                        label: '1 year ago',
                        value: defaultValues.oneYearAgo,
                    },
                    {
                        label: 'now',
                        value: defaultValues.now,
                    },
                ],
            };
        },
        methods: {
            selectBaseOption({value}, {close}) {
                this.update(value);
                close();
            },
            update(value) {
                this.$emit('input', value);
            },
            updateTyped({target: {value}}) {
                this.$emit('input', value);
            },
            openIfEmpty() {
                if (isBlank(this.value)) {
                    this.$refs.menu.openPopper();
                }
            },
        },
    };
</script>
